import { updateSurveySampleByIdApi } from '../../../api/survey.sample';
import { getSurveyQuestionsBySurveyIdAndSectionApi } from '../../../api/surveys';

// A question's code embeds its section code as the third "_" part
// ("2024_TYPE_001_Q1"); swap it for the new one, leaving codes that don't
// follow that shape untouched.
export const recodeQuestionIdentifier = (identifier, oldCode, newCode) => {
  if (!identifier) return identifier;
  const parts = identifier.split('_');
  if (parts.length < 3 || parts[2].toLowerCase() !== String(oldCode).toLowerCase()) {
    return identifier;
  }
  parts[2] = newCode.toUpperCase();
  return parts.join('_');
};

// Moves every question of a section to a new section code: the section a
// question belongs to is stored on the question itself (sectionIdentifier and
// its code), so changing a section's code means rewriting each of them.
// Updates run independently; resolves with the questions that moved and those
// that failed so the caller can report a partial result. Throws only when the
// question list itself cannot be read for a section known to have questions.
const recodeSectionQuestions = async ({ surveyId, oldCode, newCode, hasQuestions, jwt }) => {
  let questions = [];
  try {
    const section = await getSurveyQuestionsBySurveyIdAndSectionApi(surveyId, oldCode, jwt);
    questions = section?.questions || [];
  } catch (e) {
    // A section without questions has no list to return.
    if (hasQuestions) throw e;
  }

  const results = await Promise.allSettled(
    questions.map((question) => {
      const Data = { sectionIdentifier: newCode };
      if (question.code) {
        Data.identifier = recodeQuestionIdentifier(question.code, oldCode, newCode);
      }
      return updateSurveySampleByIdApi(question.id, { sampleId: question.id, Data }, jwt);
    })
  );

  const failed = questions.filter((_, index) => results[index].status === 'rejected');
  const moved = questions.filter((_, index) => results[index].status === 'fulfilled');
  return { moved, failed };
};

export default recodeSectionQuestions;
